var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolanaChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 398,
    height: 312,
    viewBox: "0 0 398 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6319 237.918C67.0654 235.486 70.3646 234.12 73.8046 234.12H391.202C396.984 234.12 399.878 241.112 395.788 245.199L333.071 307.866C330.638 310.298 327.339 311.663 323.899 311.663H6.50115C0.71916 311.663 -2.17529 304.672 1.91482 300.585L64.6319 237.918Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6319 3.7973C67.0654 1.36583 70.3646 0 73.8046 0H391.202C396.984 0 399.878 6.99174 395.788 11.0786L333.071 73.7458C330.638 76.1772 327.339 77.5431 323.899 77.5431H6.50115C0.71916 77.5431 -2.17529 70.5513 1.91482 66.4645L64.6319 3.7973Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.071 120.112C330.638 117.68 327.339 116.315 323.899 116.315H6.50115C0.719158 116.315 -2.17529 123.306 1.91482 127.393L64.6319 190.06C67.0653 192.492 70.3646 193.858 73.8046 193.858H391.202C396.984 193.858 399.878 186.866 395.788 182.779L333.071 120.112Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 268.871,
    y1: -85.491,
    x2: 49.2049,
    y2: 335.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 268.871,
    y1: -85.491,
    x2: 49.2049,
    y2: 335.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 268.871,
    y1: -85.491,
    x2: 49.2049,
    y2: 335.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaChain);
export default __webpack_public_path__ + "static/media/solana-chain.06e258d7.svg";
export { ForwardRef as ReactComponent };